<template>
  <div class="cmp-catalog-projects-project_list dt-page">
    <div class="dt-page--top-bar">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddProjectClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
      <div class="search" style="max-width: 296px">
        <InputField
          :value="searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            width: '148px'
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
      </div>
    </div>
    <div class="dt-page--body">
      <NTable
        id="catalog-projects-project_list"
        class="h1"
        :config="tableConfig"
        :headers="headers"
        :items="list"
        :loadingFlag="loadingFlag"
        @scrollnext="onProjectScroll"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            :class="{
              selected: selectedRow(item)
            }"
            @click="onProjectClicked(item)"
            :title="$t('click_to_see_project_list')"
          >
            <td v-bind="tdcon('project_name')">
              <span class="txtov" :title="item['project_name']">{{
                item["project_name"]
              }}</span>
            </td>
            <td v-bind="tdcon('release_date')">
              <span class="txtov" :title="item['min_release_date']">{{
                item["min_release_date"]
              }}</span>
            </td>
            <td v-bind="tdcon('status')">
              <span class="txtov" :title="item['status']">{{
                item["status"]
              }}</span>
            </td>
            <td v-bind="tdcon('release_identifiers')">
              <span class="txtov" :title="item['release_identifiers']">{{
                item["release_identifiers"]
              }}</span>
            </td>
            <td v-bind="tdcon('options')">
              <img
                src="static/icons/delete.svg"
                @click.stop="e => onProjectDelete(item)"
                class="dt-icon v5 s2 ut-center"
                alt
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>

    <Sidewindow
      :navConfig="defaultConfig"
      :value="projectDetailsFlag"
      @closed="onCloseProjectDetails"
    >
      <ProjectsSidewindow />
    </Sidewindow>

    <ModalContainer :modalKey="'addProject'" :width="'small'">
      <AddProject
        :statusList="list"
        @cancelled="onDialogCancelled"
        @added="onAdded"
      />
    </ModalContainer>
  </div>
</template>

<script>
import InputField from "@plugins/text-field/input-field";
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "@/plugins/datatable/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import * as ActionTypes from "../../store/types";
import { CatalogStoreNamespace as storeNS } from "../../store";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { projectsCatalogActions } from "../../store/projects/actions";
import { projectsCatalogGetters } from "../../store/projects/getters";
import { Subject } from "rxjs";
import { createModalMixin } from "../../../../dt-plugins/modal/modal.mixin";
import { subscribeSubject, subscribeSubjectND } from "../../../../utility";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { LoadedEnd } from "../../../../dt-plugins/advanced-search/load.model";
import {
  getProjectsDetailsSelectable,
  projectsListLDTRoutes
} from "../../router/routes";
import {
  childOfOrEqualDetails,
  handleFromRoute
} from "../../../../utility/route";
import {
  createLDTHost,
  defaultConfig
} from "../../../../dt-plugins/sidewindow";

import AddProject from "./add-project";
import ProjectsSidewindow from "./projects-sidewindow";

const listLength = 100;

const LDTConfig = {
  entityName: "project",
  ldtRoutes: projectsListLDTRoutes,
  detailsSelectableFunction: getProjectsDetailsSelectable,
  primaryKey: "project_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.ProjectDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.ProjectDetails.FETCH.SINGLE
};

export default {
  components: {
    InputField,
    DTIconButton,
    NTable,
    ModalContainer,

    AddProject,
    ProjectsSidewindow
  },
  data: function() {
    return {
      searchString: "",
      searchSubject: new Subject(),

      loadedStart: 0,
      loadedEnd: false,
      startFrom: 0,
      row_count: 100, // FIXED because of Initial API
      scrollSubject: new Subject(),
      loadingFlag: false,

      selectedClickedProject: null,

      defaultConfig: defaultConfig,
      getProjectsDetailsSelectable: getProjectsDetailsSelectable
    };
  },
  mounted: async function() {
    this.fetchListReset();

    subscribeSubject(this, this.searchSubject, searchString => {
      this.fetchListReset();
    });
    subscribeSubjectND(this, this.scrollSubject, scrollTop => {
      if (this.startFrom == this.loadedStart) {
        this.startFrom += this.row_count;
        this.fetchListNext();
      }
    });
  },
  mixins: [createLDTHost(LDTConfig), createModalMixin("addProject")],
  watch: {
    $route: {
      immediate: true,
      handler: function(to, from) {}
    }
  },
  computed: {
    ...mapGetterObject(storeNS, projectsCatalogGetters),

    tableConfig: function() {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40
      });
    },
    list: function() {
      return this.projectList?.all_l_projects || [];
      // return this.projectList && this.projectList.all_l_projects || [];
    },
    headers: function() {
      return [
        createTableHeader("project_name", { fw: 700 }),
        createTableHeader("release_date", { f: 0.5, mw: 130 }),
        createTableHeader("status", { f: 0.5, mw: 130 }),
        createTableHeader("release_identifiers", { f: 2 }),
        createTableHeader("options", { text: false, mw: 40 })
      ];
    },
    filter: function() {
      return {
        searchString: this.searchString,
        startFrom: this.startFrom,
        row_count: this.row_count
      };
    },
    projectDetailsFlag: function() {
      return childOfOrEqualDetails(projectsListLDTRoutes, this.$route);
    }
  },
  methods: {
    ...mapActionObject(storeNS, projectsCatalogActions),

    fetchListReset: function() {
      this.startFrom = 0;
      this.loadedStart = 0;
      this.loadedEnd = false;
      this.fetchList();
    },
    fetchList: async function() {
      if (this.loadedEnd === false) {
        this.loadingFlag = true;

        const loadStatus = await this[ActionTypes.ProjectList.FETCH.ALL](
          this.filter
        );

        if (loadStatus === LoadedEnd) {
          this.loadedEnd = true;
        }
        this.loadingFlag = false;
      }
    },
    fetchListNext: async function() {
      await this.fetchList();
      this.loadedStart = this.startFrom;
    },
    onSearchInputKeyup: function(event) {
      this.searchString = event.target.value;
      this.searchSubject.next(this.searchString);
    },
    onAddProjectClick: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_project"
        }
      });
    },
    onDialogCancelled: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined
        }
      });
    },
    onProjectScroll: function(value) {
      console.log("Project Scroll");
      this.scrollSubject.next(value);
    },
    selectedRow: function(track) {
      return (
        this.selectedClickedProject &&
        this.selectedClickedProject["project_id"] == track["project_id"]
      );
    },

    onAdded: async function(item) {
      this.fetchList();
      this.onDialogCancelled();
    },

    onProjectDelete: async function(item) {
      console.log("Project deleted ", item);
      const confirmationResult = await confirmDelete(
        "project",
        item.project_name
      );
      if (confirmationResult === "OK") {
        console.log("Okkkkk");
        this[ActionTypes.ProjectList.DELETE.SINGLE](item);
      }
    },
    // Start Sidewindow
    onProjectClicked: function(project) {
      console.log("LLLLLLL ", project);
      this.selectedClickedProject = project;
      this.$router.push({
        name: projectsListLDTRoutes.names.tab,
        params: {
          project_id: project.project_id,
          tab: "overview"
        }
      });
    },
    onCloseProjectDetails: function() {
      this.selectedClickedProject = null;
      handleFromRoute(this, () => {
        this.$router.push({
          name: projectsListLDTRoutes.names.list
        });
      });
    }
    // End Sidewindow
  }
};
</script>

<style lang="scss" scoped>
.cmp-catalog-projects-project_list {
  .dt-page--body {
    --offset: 120px;
  }
}
</style>
